/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Input, InputNumber, Button, Select, Switch, Card, Row, Col, message } from 'antd';
import { serviceService, serviceCategoryService } from '../../../services/serviceService';
import Breadcrumb from '../../../components/ui/Breadcrumb';

const AddService = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [form] = Form.useForm();
  const serviceId = searchParams.get('id');
  const isEdit = Boolean(serviceId);

  const fetchCategories = useCallback(async () => {
    try {
      const response = await serviceCategoryService.getAll({ per_page: 100, is_active: true });
      setCategories(response.data || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
      message.error('Error al cargar categorías');
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    if (isEdit) {
      loadService();
    }
  }, [isEdit, serviceId]);

  const loadService = async () => {
    try {
      const service = await serviceService.getById(parseInt(serviceId));
      form.setFieldsValue({
        name: service.name,
        code: service.code,
        category_id: service.category_id,
        description: service.description,
        duration_minutes: service.duration_minutes,
        is_active: service.is_active
      });
    } catch (error) {
      message.error('Error al cargar servicio');
      navigate('/services');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await serviceService.update(parseInt(serviceId), values);
        message.success('Servicio actualizado correctamente');
      } else {
        await serviceService.create(values);
        message.success('Servicio creado correctamente');
      }
      navigate('/services');
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Error al guardar servicio';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">{isEdit ? 'Editar' : 'Agregar'} Servicio</h3>
                <Breadcrumb items={[{ label: 'Inicio', to: '/' }, { label: 'Servicios', to: '/services' }, { label: isEdit ? 'Editar' : 'Agregar' }]} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Card>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  initialValues={{
                    is_active: true
                  }}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Nombre"
                        name="name"
                        rules={[{ required: true, message: 'El nombre es requerido' }]}
                      >
                        <Input placeholder="Nombre del servicio" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Código"
                        name="code"
                        rules={[{ required: true, message: 'El código es requerido' }]}
                      >
                        <Input placeholder="Código único" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Categoría"
                        name="category_id"
                        rules={[{ required: true, message: 'La categoría es requerida' }]}
                      >
                        <Select
                          placeholder="Seleccione una categoría"
                          showSearch
                          optionFilterProp="children"
                        >
                          {categories.map(c => (
                            <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Duración (minutos)"
                        name="duration_minutes"
                      >
                        <InputNumber min={1} style={{ width: '100%' }} placeholder="Duración en minutos" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    label="Descripción"
                    name="description"
                  >
                    <Input.TextArea rows={2} placeholder="Descripción del servicio" />
                  </Form.Item>

                  <Form.Item
                    label="Estado"
                    name="is_active"
                    valuePropName="checked"
                  >
                    <Switch checkedChildren="Activo" unCheckedChildren="Inactivo" />
                  </Form.Item>

                  <Form.Item className="text-end">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      className="me-2"
                    >
                      {isEdit ? 'Actualizar' : 'Guardar'}
                    </Button>
                    <Button onClick={() => navigate('/services')}>
                      Cancelar
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
    </>
  );
};

export default AddService;
